import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SidebarState {
  collapsed: boolean;
}

interface SidebarAction {
  toggleCollapsed: () => void;
  setCollapsed: (value: boolean) => void;
}

export const useSidebarStore = create<SidebarState & SidebarAction>()(
  devtools(
    persist(
      (set) => ({
        collapsed: false,
        toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
        setCollapsed: (value: boolean) => set({ collapsed: value }),
      }),
      { name: 'sidebar-collapsed' }
    )
  )
);
